// Vendors
import React from 'react';

import { tablefy } from '../../../components/helpers';

const UpdateProjectStatus = ({
  builderMeta,
  openAccordion,
  handleToggleAccordion
}) => (
  <div className="grid__col-xs-12 u--margin-bottom-20">
    <button
      className={`btn btn--white btn--block btn--lg btn--pip-accordion btn--has-arrow module-hover-root ${
        openAccordion['builder-details'] === true
          ? 'btn--pip-accordion--on'
          : ''
      }`}
      type="button"
      onClick={() => handleToggleAccordion('builder-details')}
    >
      <span className="btn__content u--display-flex u--align-items-center u--justify-content-space-between u--padding-left-20 u--padding-right-20 u--padding-top-5 u--padding-bottom-5 u--height-auto">
        <span className="btn__text">Builder Details & W-9</span>
        <span className="btn__arrow"></span>
      </span>
    </button>
    <div
      className={
        openAccordion['builder-details'] === true
          ? 'u--display-block u--padding-top-20 u--squash-end u--padding-bottom-10'
          : 'u--display-none'
      }
    >
      {tablefy(
        {
          'Company:': builderMeta.company,
          'Contract:':
            builderMeta.documentContractUrl != false ? (
              <a href={builderMeta.documentContractUrl} target="_blank">
                {new Date().getFullYear()}
              </a>
            ) : (
              <span className="u--color-gray-light">--</span>
            ),
          'W-9':
            builderMeta.has_uploaded_w9 != false ? (
              <>{builderMeta.has_uploaded_w9} (Bill.com)</>
            ) : (
              <span className="u--color-gray-light">--</span>
            ),
          'Name:': `${builderMeta.first_name} ${builderMeta.last_name}`,
          'Email:': builderMeta.user_email,
          'Phone:': builderMeta.phone,
          'Address:': builderMeta.address,
          'Address 2:': builderMeta.address2 ? builderMeta.address2 : 0,
          'City:': builderMeta.city,
          'State:': builderMeta.state,
          'Zip:': builderMeta.zip_code
        },
        true
      )}
    </div>
  </div>
);

export default UpdateProjectStatus;
